import { useQuery } from "@tanstack/react-query";
import { fetchAffiliateEarningsSummary, fetchAffiliatePayments } from "../utils/affiliateApi";

export const useAffiliatePayments = ({
  start_date = null,
  end_date = null,
  limit = 20,
  offset = 0,
  enabled = true,
} = {}) => {
  return useQuery({
    queryKey: ["affiliate", "analytics", "payments", { start_date, end_date, limit, offset }],
    queryFn: () => fetchAffiliatePayments({ start_date, end_date, limit, offset }),
    enabled,
    refetchOnWindowFocus: false,
  });
};

export const useAffiliateEarningsSummary = ({ months = 6, enabled = true } = {}) => {
  return useQuery({
    queryKey: ["affiliate", "earnings", "summary", { months }],
    queryFn: () => fetchAffiliateEarningsSummary({ months }),
    enabled,
    refetchOnWindowFocus: false,
  });
};
